<ng-container *transloco="let t">

  <div class="badge-header mb-16">
    <div class="finished-event-ribbon d-flex justify-content-between align-items-center">
      <div class="finished-event-ribbon__status text-uppercase">
        @if(isFinishedEvent){
        <span>{{ t('event.item.status.2') }}</span>
        }
      </div>
      <div class="race-sport-wrapper">
        <span class="race-date-wrapper__month text-uppercase pe-2"
          [innerHTML]="race && race.raceStart ? formatDate(race.raceStart) : ''"></span>
        <span [innerHTML]="race && race.raceStart ? (race.raceStart | date:'d') : ''"></span>
        @if(checkSameDate(race)){
        <div>
          -
          <span [innerHTML]="race && race.raceEnd? (race.raceEnd | date:'d') : ''"></span>
        </div>
        }
        <span>.</span>
        <span [innerHTML]="race && race.raceStart ? (race.raceStart | date:'yyyy') : ''"></span>
      </div>
    </div>
    <div class="badge-header__title">
      @if(!isFinishedEvent && wspayConfirmation?.paymentStatus !== WsPaymentStatus.PENDING){
      <ng-container>
        <img src="assets/img/rounded-check.svg" alt="Checkmark" class="me-2">
        <span class="text-uppercase">
          {{ t('app.common.registered') }}
        </span>
      </ng-container>
      }
      @if(isFinishedEvent && wspayConfirmation?.paymentStatus !== WsPaymentStatus.PENDING){
      <span class="text-uppercase">
        {{ t('app.common.finished') }}
      </span>
      }

      @if(wspayConfirmation?.paymentStatus === WsPaymentStatus.PENDING){
      <span>
        {{ t('app.common.pending') }}
      </span>
      }

    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between">
    <div class="flex-grow-1">
      <div class="fw-bold fs-18-16 mb-4">
        <app-language-output [hrLabel]="race?.name" [srLabel]="race?.nameSr"  [bsLabel]="race?.nameBs" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
          [siLabel]="race?.nameSlo" [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages" />
      </div>
      <div class="race-details">
        <div class="race-details__item">
          <div class="race-details__content">
            <div class="fs-16"> {{ race?.sport ? t("app.common.sports." + race?.sport) : '' }}
            </div>
          </div>
        </div>
        <div class="race-details__item">
          <div class="race-details__content">
            <div class="fs-16">
              {{race?.length}} m
            </div>
          </div>
        </div>
        <div class="race-details__item">
          <div class="race-details__content">
            {{ validCityAndCountry(country,race?.startCity)}}
          </div>
        </div>
      </div>
    </div>
    @if(wspayConfirmation?.paymentStatus === WsPaymentStatus.PENDING){
    <ng-container>
      <div class="d-inline-block">
        <app-rounded-button [label]="t('app.common.pay.now')" />
      </div>
    </ng-container>
    }
  </div>
  <div class="vertical-separator"></div>
</ng-container>
